<template>
  <div class="demo">
    <transition name="fade">
      <router-view></router-view>
    </transition>
  </div>
</template>
<script>
/**
 * ==================================================================================
 * Dev layout
 * ==================================================================================
 **/

export default {}
</script>
<style scoped lang="scss">
.demo {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
}
</style>
